import React, { Suspense, useEffect, useMemo, useState } from "react";
import LoadingSpinner from "../../components/UI/loadingSpinner/LoadingSpinner";
import { ROUTES } from "../../constants/routes";
import { downloadCSV } from "../../utils/csv";
import {
  attendanceTimeDetailReportHeaders,
  attendanceTimeReportHeaderMapping,
  PAGINATION_SEQUENCE,
} from "../../constants";
import ExportIcon from "../../components/icons/ExportIcon";
import { Icon } from "@iconify/react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import DataTable, { TableColumn } from "react-data-table-component";
import { getApi } from "../../services/http.service";
import { IAttendance } from "../../interfaces/attendance.interface";
import { Link } from "react-router-dom";
import { IEmployee } from "../../interfaces/employee.interface";
import { TIME_DETAILS_COLUMNS } from "./columns";

function TimeDetails() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const [queryParams] = useSearchParams();
  // Data & Search
  const [startDate, setStartDate] = useState(queryParams.get("startDate"));
  const [endDate, setEndDate] = useState(queryParams.get("endDate"));
  const [filteredData, setFilteredData] = useState<IAttendance[]>([]);
  const [employee, setEmployee] = useState<IEmployee>();
  useEffect(() => {
    fetchNews();
  }, [startDate, endDate]);

  const fetchNews = async () => {
    try {
      setLoading(true);
      const result = await getApi(
        ROUTES.GET_ALL_ATTENDANCE_BY_EMPLOYEE + params?.id,
        {
          startDate,
          endDate,
        }
      );
      if (result.code === 200) {
        setFilteredData(result?.data);
        setTotalRows(result.total); // Set total records
        setEmployee(result?.employee);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // Handle Page Change
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  // Handle Rows per Page Change
  const handlePerRowsChange = (newPerPage: number, newPage: number) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const columns: TableColumn<IAttendance>[] = useMemo(
    () => TIME_DETAILS_COLUMNS,
    []
  );

  async function selectedChangeHandler(e: any) {
    const s = e[0].toString();
    const en = e[1]?.toString();
    if (s && en) {
      setStartDate(s);
      setEndDate(en);
    }
  }

  return (
    <section>
      <div className="d-flex justify-content-between flex-wrap">
        <div className="d-flex align-items-center">
          <button className="nav-link" onClick={() => navigate(-1)}>
            <Icon icon="material-symbols:arrow-back-rounded" fontSize={25} />
          </button>
          <h2 className="title mb-2"> Attendance Time Details </h2>
        </div>
        <div className="d-flex flex-wrap align-items-center">
          <span className="ms-2">
            <button
              className="btn btn-primary"
              onClick={() => {
                downloadCSV(
                  filteredData,
                  attendanceTimeDetailReportHeaders,
                  attendanceTimeReportHeaderMapping,
                  "Groove_Attendance"
                );
              }}
            >
              <ExportIcon />
              <span className="ps-1"> Export</span>
            </button>
          </span>
        </div>
      </div>
      <div className="position-relative">
        <h6>Employee: {employee?.fullName}</h6>
        <div className="fs-7 mb-1">
          <div>
            <span>Email: {employee?.email}</span>
          </div>
          <div>
            <span>Phone: {employee?.phone}</span>
          </div>
          <div>
            <span>
              Address: {employee?.address?.street} {employee?.address?.city}{" "}
              {employee?.address?.state} {employee?.address?.country} -{" "}
              {employee?.address?.pincode}
            </span>
          </div>
        </div>
        <div className="position-absolute top-0 end-0">
          <Link to={`/employees/${employee?._id}`} title="View Employee">
            <Icon
              icon="material-symbols:frame-person-sharp"
              type="button"
              color="#9bcb51"
              style={{ marginInline: 5 }}
              fontSize={25}
            />
          </Link>
        </div>
      </div>
      <Suspense>
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationPerPage={perPage}
          paginationRowsPerPageOptions={PAGINATION_SEQUENCE}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          highlightOnHover
          striped
          progressPending={loading}
          progressComponent={<LoadingSpinner />}
        />
      </Suspense>
    </section>
  );
}

export default TimeDetails;
